import { render, staticRenderFns } from "./userInfoList.vue?vue&type=template&id=b37a379a&scoped=true"
import script from "./userInfoList.vue?vue&type=script&lang=js"
export * from "./userInfoList.vue?vue&type=script&lang=js"
import style0 from "./userInfoList.vue?vue&type=style&index=0&id=b37a379a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37a379a",
  null
  
)

export default component.exports